module.exports = __webpack_public_path__ + "img/inMeIcon.bace0f07.svg";